export default __webpack_public_path__ + "static/media/Office_line.3d6efd6b.svg";